import { render } from "./viewed-shift.vue?vue&type=template&id=54cbab86"
import script from "./viewed-shift.vue?vue&type=script&lang=js"
export * from "./viewed-shift.vue?vue&type=script&lang=js"

import "./viewed-shift.vue?vue&type=style&index=0&id=54cbab86&lang=scss"
script.render = render

export default script